<div class="row app-footer">
  <div
    class="footer-changelog"
    (click)="onChangelogClick()">
    <mat-icon
      svgIcon="version"
      class="footer-icon"></mat-icon
    ><span>Version: {{ version }}</span>
    <span
      class="footer-environment"
      *ngIf="!isProduction"
      >{{ env }}</span
    >
  </div>
  <!-- <div
    class="footer-old-wimt"
    (click)="onGotoOldWimtClick()">
    <p class="footer-old-wimt-text">
      <mat-icon
        svgIcon="reply--all"
        class="footer-icon"></mat-icon
      >{{ linkName }}
    </p>
  </div> -->
</div>
